import Vue from "vue";
import {
  isRegionScope,
  resolveWeiShopApi,
} from "@/views/apps/weishop/region/utils/regionApiMap";

const request = () => Vue.prototype.axios;
const api = (url) => resolveWeiShopApi(url);

function currentRegionStoreId() {
  return sessionStorage.getItem("currentRegionStoreId") || "";
}

export function withStoreParams(params) {
  if (!isRegionScope()) return params || {};
  const storeId = currentRegionStoreId();
  return storeId ? Object.assign({}, params || {}, { store_id: storeId }) : (params || {});
}

function withStorePayload(data) {
  if (!isRegionScope()) return data;
  const storeId = currentRegionStoreId();
  if (!storeId) return data;
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    if (!data.has("store_id")) data.append("store_id", storeId);
    return data;
  }
  return Object.assign({}, data || {}, { store_id: storeId });
}

export const listApplyments = (params) =>
  request().get(api("/api/weishop/admin/wechat-applyments"), { params });
export const getApplyment = (id) =>
  request().get(api(`/api/weishop/admin/wechat-applyments/${id}`));
export const getApplymentPrefill = (params) =>
  request().get(api("/api/weishop/admin/wechat-applyments/prefill"), { params });
export const getApplymentDictionaries = () =>
  request().get(api("/api/weishop/admin/wechat-applyments/dictionaries"));
export const getHeadApplymentProfile = () =>
  request().get(api("/api/weishop/admin/wechat-applyments/head-profile"));
export const getApplymentBanks = (params) =>
  request().get(api("/api/weishop/admin/wechat-applyments/banks"), { params });
export const getApplymentBankProvinces = () =>
  request().get(api("/api/weishop/admin/wechat-applyments/bank-provinces"));
export const getApplymentBankCities = (params) =>
  request().get(api("/api/weishop/admin/wechat-applyments/bank-cities"), { params });
export const getApplymentBankBranches = (params) =>
  request().get(api("/api/weishop/admin/wechat-applyments/bank-branches"), { params });
export const saveApplyment = (data) =>
  request().post(api("/api/weishop/admin/wechat-applyments"), data);
export const uploadApplymentFile = (data) =>
  request().post(api("/api/weishop/admin/wechat-applyments/upload-file"), data);
export const recognizeApplymentFile = (data) =>
  request().post(api("/api/weishop/admin/wechat-applyments/recognize-file"), data);
export const submitApplyment = (id) =>
  request().post(api(`/api/weishop/admin/wechat-applyments/${id}/submit`));
export const syncApplyment = (id) =>
  request().post(api(`/api/weishop/admin/wechat-applyments/${id}/sync`));
export const withdrawApplyment = (id) =>
  request().post(api(`/api/weishop/admin/wechat-applyments/${id}/withdraw`));
export const syncApplymentConfirm = (id) =>
  request().post(api(`/api/weishop/admin/wechat-applyments/${id}/confirm/sync`));
export const activateApplyment = (id) =>
  request().post(api(`/api/weishop/admin/wechat-applyments/${id}/activate`));
export const getTransferAuthorization = (id) =>
  request().get(api(`/api/weishop/admin/wechat-applyments/${id}/transfer-authorization`));
export const applyTransferAuthorization = (id) =>
  request().post(api(`/api/weishop/admin/wechat-applyments/${id}/transfer-authorization/apply`));
export const refreshTransferAuthorization = (id) =>
  request().post(api(`/api/weishop/admin/wechat-applyments/${id}/transfer-authorization/refresh`));
export const checkProfileReadiness = (id) =>
  request().post(api(`/api/weishop/admin/wechat-applyments/profiles/${id}/readiness`));
export const enableProfile = (id) =>
  request().post(api(`/api/weishop/admin/wechat-applyments/profiles/${id}/enable`));

export const getStoreApplyment = (params) =>
  request().get(api("/api/weishop/store/store/wechat-applyment"), { params: withStoreParams(params) });
export const listStoreApplyments = (params) =>
  request().get(api("/api/weishop/store/store/wechat-applyment/list"), { params: withStoreParams(params) });
export const getStoreApplymentPrefill = (params) =>
  request().get(api("/api/weishop/store/store/wechat-applyment/prefill"), { params: withStoreParams(params) });
export const getStoreApplymentBanks = (params) =>
  request().get(api("/api/weishop/store/store/wechat-applyment/banks"), { params: withStoreParams(params) });
export const getStoreApplymentBankProvinces = () =>
  request().get(api("/api/weishop/store/store/wechat-applyment/bank-provinces"), { params: withStoreParams({}) });
export const getStoreApplymentBankCities = (params) =>
  request().get(api("/api/weishop/store/store/wechat-applyment/bank-cities"), { params: withStoreParams(params) });
export const getStoreApplymentBankBranches = (params) =>
  request().get(api("/api/weishop/store/store/wechat-applyment/bank-branches"), { params: withStoreParams(params) });
export const saveStoreApplyment = (data) =>
  request().post(api("/api/weishop/store/store/wechat-applyment"), withStorePayload(data));
export const uploadStoreApplymentFile = (data) =>
  request().post(api("/api/weishop/store/store/wechat-applyment/upload-file"), withStorePayload(data));
export const recognizeStoreApplymentFile = (data) =>
  request().post(api("/api/weishop/store/store/wechat-applyment/recognize-file"), withStorePayload(data));
export const submitStoreApplyment = () =>
  request().post(api("/api/weishop/store/store/wechat-applyment/submit"), withStoreParams({}));
export const syncStoreApplyment = () =>
  request().post(api("/api/weishop/store/store/wechat-applyment/sync"), withStoreParams({}));
export const syncStoreApplymentConfirm = () =>
  request().post(api("/api/weishop/store/store/wechat-applyment/confirm/sync"), withStoreParams({}));
export const checkStoreProfileReadiness = () =>
  request().post(api("/api/weishop/store/store/wechat-applyment/readiness"), withStoreParams({}));
export const enableStoreProfile = (id) =>
  request().post(api(`/api/weishop/store/store/wechat-applyment/profiles/${id}/enable`), withStoreParams({}));
